import { IsEnum, IsInt, IsNotEmpty, IsOptional, IsString, IsUUID, Min } from "class-validator";

export enum PlannerResourceType {
  BASIC = 'BASIC',
  PLACE = 'PLACE',
  ACTIVITY = 'ACTIVITY',
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT'
}

export class AddPlannerResourceDto {
  @IsString()
  @IsNotEmpty()
  title!: string

  @IsEnum(PlannerResourceType)
  plannerResource!: PlannerResourceType

  @IsInt()
  @Min(1)
  @IsOptional()
  position?: number

  @IsUUID()
  @IsOptional()
  parentId?: string
}
